'use client'
import type { LocaleString } from '@/.generated/sanityTypes/graphql'
import { useLocale } from 'next-intl'
import type { Locale } from '@/i18n'
import Link from 'next/link'
import type { AnnualReportProjectLink } from '@/.generated/sanityTypes/graphql'
import { withNewLines } from '@/lib/newline'
import Image from '@/components/Image'

type ContentWithLinksBlockProps = {
  title: LocaleString
  projectLinks: AnnualReportProjectLink[]
}

const ContentWithLinksBlock = ({
  title,
  projectLinks,
}: ContentWithLinksBlockProps) => {
  const locale = useLocale() as Locale

  return (
    <div className="text-gray-dark bg-gray-medium relative flex flex-col justify-center text-center">
      <div className="flex justify-center">
        <h2 className="px-20 pt-14 text-lg font-medium md:text-3xl md:leading-10 lg:px-0">
          {withNewLines(title?.[locale])}
        </h2>
      </div>
      {projectLinks && (
        <div className="grid-col-1 m-auto grid max-w-screen-2xl gap-7 px-6 py-8 md:grid-cols-3 md:px-16 md:py-16">
          {projectLinks.map((project) => {
            return (
              <Link
                className="bg-white"
                key={project?._key}
                href={`/${locale}/${project?.link?.year}/${
                  project.link?.pageSlug?.current || ''
                }`}
              >
                <div className="relative aspect-[3/2]">
                  {project.image?.asset && (
                    // eslint-disable-next-line jsx-a11y/alt-text
                    <Image image={project.image} fill cover />
                  )}
                </div>
                <div className="bg-white px-10 pb-5 md:px-2">
                  <h3 className="pt-4 md:text-xl">
                    {withNewLines(project?.title?.[locale])}
                  </h3>
                  <p className="font-light text-gray-400">
                    {project?.subtitle?.[locale]}
                  </p>
                </div>
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ContentWithLinksBlock
